<template>
  <div>
    <v-server-table
      :columns="tableColumns"
      :options="tableOptions"
      ref="subtestResultsTable"
      @row-click="selectSubtest">
      <span slot="createdAt" class="no-break" slot-scope="{row}">{{
          row.createdAt | localTime('YYYY-MM-DD HH:mm')
        }}</span>
      <span slot="sequencesCorrect" class="no-break" slot-scope="{row}">{{ row.sequencesCorrect || "N/A" }}</span>
      <span slot="difficultyLevel" class="no-break" slot-scope="{row}">{{ row.difficultyLevel || "N/A" }}</span>
      <span slot="stimulusType" class="no-break" slot-scope="{row}">{{ row.stimulusType || "N/A" }}</span>
      <span slot="outputType" class="no-break" slot-scope="{row}">{{
          row.outputType ? $t(`audiology_4_all.values.outputType.${row.outputType}`) : "N/A"
        }}</span>
      <span slot="frequency" class="no-break" slot-scope="{row}">{{
          row.frequenciesIntensitiesGiven.length > 0 ? buildFrequencyString(row.frequenciesIntensitiesGiven.filter(elem => elem.adjustmentType === 'fine_adjustment')[0]) : "N/A"
        }}</span>
      <span slot="intensity" class="no-break" slot-scope="{row}">{{
          row.frequenciesIntensitiesGiven.length > 0 ? buildIntensityString(row.frequenciesIntensitiesGiven.filter(elem => elem.adjustmentType === 'fine_adjustment')[0]) : "N/A"
        }}</span>
      <span slot="stimulusType" class="no-break" slot-scope="{row}">{{
          row.stimulusType ? $t(`audiology_4_all.values.stimulusType.${row.stimulusType}`) : "N/A"
        }}</span>

      <span slot="result" class="no-break" slot-scope="{row}">{{
         row.result ? row.result.recommendation : "N/A"
        }}</span>
    </v-server-table>

    <A4ASubtestDetailsModal
      v-if="selectedSubtest && selectedSubtest.answersGiven.length > 0"
      :subtest="selectedSubtest"
      @closeModal="selectedSubtest=null">
    </A4ASubtestDetailsModal>

    <hearing-test-modal
      v-if="selectedHearingTest"
      :allowDownload="false"
      :hearingTest="selectedHearingTest"
      @closeModal="selectedHearingTest = null">
    </hearing-test-modal>
  </div>
</template>

<script>
import TableQueryMixin from "@/mixins/TableQueryMixin";
import A4ASubtestDetailsModal from "@/components/clinical/accounts/AccountDetails/A4A/A4ASubtestDetailsModal";
import Vue from "vue";
import HearingTestModal from "@/components/clinical/accounts/AccountDetails/HearingTestModal.vue";
import ApiService from "@/api/ApiService";
import axios from 'axios';
export default {
  components: {HearingTestModal, A4ASubtestDetailsModal},
  props: {
    account: {
      type: Object,
      required: true
    },
    testSessionId: {
      type: String,
      required: false
    },
    subtest: {
      type: Object,
      required: true,
      default: ''
    }
  },
  mixins: [
    TableQueryMixin
  ],
  data: function () {
    return {
      isOpen: false,
      selectedSubtest: null,
      selectedHearingTest: null,
      queryUrl: `${process.env.VUE_APP_A4A_URL}/v1/tests/admin/user/${this.account.id}/subtest/${this.subtest.id}/finished`,
      tableColumns: ['createdAt', 'sequencesCorrect', 'difficultyLevel', 'stimulusType', 'outputType', 'frequency', 'intensity', 'result', 'finishedTonalTest.hlLeft', 'finishedTonalTest.hlRight', 'finishedTonalTest.device'],
      tableOptions: {
        requestFunction: (data) => {
          const page = data.page
          return new Promise((resolve, reject) => {
            if (this.cancelationCallback !== null) {
              this.cancelationCallback()
            }
            const limit = this.$refs.subtestResultsTable ? this.$refs.subtestResultsTable.limit : 10
            const queryUrl = this.queryUrl
            if(this.testSessionId) {
              data.testSessionId = this.testSessionId
            }
            ApiService.cancelableQuery(queryUrl, data, new axios.CancelToken(c => {
              this.cancelationCallback = c
            }))
              .then(response => {
                if (response.data.page) {
                  if (this.getTableReference) {
                    this.getTableReference().$refs.pagination.Page = response.data.page
                  }
                } else if (page) {
                  if (this.getTableReference) {
                    this.getTableReference().$refs.pagination.Page = page
                  }
                }
                this.hasMadeFirstLoad = true
                resolve({
                  data: response.data.data ? response.data.data : response.data.items,
                  count: response.data.meta.total,
                  page: response.data.meta.current_page
                })
              })
              .catch(error => {
                if (!axios.isCancel(error)) {
                  reject(error)
                }
              })
          })
        },
        filterable: false,
        sortable: [],
        headings: {
          createdAt: this.$t('audiology_4_all.titles.columnTitles.createdAt'),
          sequencesCorrect: this.$t('audiology_4_all.titles.columnTitles.sequencesCorrect'),
          difficultyLevel: this.$t('audiology_4_all.titles.columnTitles.difficultyLevel'),
          stimulusType: this.$t('audiology_4_all.titles.columnTitles.stimulusType'),
          outputType: this.$t('audiology_4_all.titles.columnTitles.outputType'),
          frequency: this.$t('audiology_4_all.titles.columnTitles.frequency'),
          intensity: this.$t('audiology_4_all.titles.columnTitles.intensity'),
          result: this.$t('audiology_4_all.titles.columnTitles.result'),
          'finishedTonalTest.hlLeft': this.$t('accounts.hl_left'),
          'finishedTonalTest.hlRight': this.$t('accounts.hl_right'),
          'finishedTonalTest.device': this.$t('accounts.device')
        },
        columnsDropdown: false
      },
    }
  },
  mounted: function() {
    this.toggleOrHideColumns()
  },
  computed: {
    a4aServiceUrl: function () {
      return `${process.env.VUE_APP_A4A_URL}/v1/tests`
    },
  },
  methods: {
    getTableReference: function () {
      return this.$refs.subtestResultsTable
    },
    selectSubtest: function ({row}) {
      Vue.nextTick(() => {
        this.selectedSubtest = row
        if(row.subtest.slug === 'tonalTest') {
          this.selectedHearingTest = {
            id: row.finishedTonalTest.id,
            hl_left: row.finishedTonalTest.hlLeft,
            hl_right: row.finishedTonalTest.hlRight,
            device_model: row.finishedTonalTest.device,
            result: this.handleHearingTestResultStr(row.finishedTonalTest)
          }
        }
      })
    },
    handleHearingTestResultStr: function (finishhedTonalTest) {
   //return "F\t4000\t250\t2000\t8000\t1000\t500\nR\t17.700005\t48.800003\t49.900005\t42.300003\t48.900005\t37.800003\nL\t43.400005\t37.400005\t49.900005\t17.700005\t36.900005\t48.900005"
      const frequenciesStr = finishhedTonalTest.results.map(result => result.frequency).join("\t")
      const leftStr = finishhedTonalTest.results.map(result => result.resultLeft).join("\t")
      const rightStr = finishhedTonalTest.results.map(result => result.resultRight).join("\t")
      return `F\t${frequenciesStr}\nR\t${rightStr}\nL\t${leftStr}`
    },
    toggleOrHideColumns: function () {
      const allColumns = this.tableColumns
      const pacColumns = ['createdAt', 'sequencesCorrect', 'difficultyLevel', 'stimulusType', 'outputType', 'frequency', 'intensity', 'result']
      const esforcAuditColumns = ['createdAt', 'sequencesCorrect', 'difficultyLevel', 'outputType', 'result']
      const zumbidosColumns = ['createdAt', 'outputType', 'frequency', 'intensity', 'result']
      const tonalTestColumns = ['createdAt', 'finishedTonalTest.hlLeft', 'finishedTonalTest.hlRight', 'finishedTonalTest.device']
      switch (this.subtest.slug) {
        case "integibilidade":
        case "esforcoAuditivo":
          allColumns.filter(column => !esforcAuditColumns.includes(column)).forEach(column => this.$refs.subtestResultsTable.toggleColumn(column))
          break
        case "zumbidos":
          allColumns.filter(column => !zumbidosColumns.includes(column)).forEach(column => this.$refs.subtestResultsTable.toggleColumn(column))
          break
        case "tonalTest":
          allColumns.filter(column => !tonalTestColumns.includes(column)).forEach(column => this.$refs.subtestResultsTable.toggleColumn(column))
          break
        case "memSeqNaoVerb":
        case "memSeqVerb":
        case "padraoDuracao":
        case "padraoFreq":
          allColumns.filter(column => !pacColumns.includes(column)).forEach(column => this.$refs.subtestResultsTable.toggleColumn(column))
          break

      }
    },
    buildIntensityString: function (data) {
      return `${data.intensity.toFixed(1)} (${this.$t(`clinical.labels.${data.earSide}`)})`
    },
    buildFrequencyString: function (data) {
      return `${Math.round(data.frequency)} (${this.$t(`clinical.labels.${data.earSide}`)})`
    }
  }
}
</script>

<style scoped>

</style>
